import { Injectable } from '@angular/core';
import { FormExtractorService } from 'src/app/modules/shared/services/form-extractor.service';
import { Lot } from '../../models/Lot';
import { TypeLotsMAPA } from '../../models/TypeLotsMAPA';

@Injectable({
  providedIn: 'root'
})
export class LotsService {

  constructor() {
  }

  getLots(controls: any, formExtractorService: FormExtractorService) {
    let lot_iter = 0;

    const lot_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_Initial'], 'SepSep_TypeLotsMAPA_index_');


    const lots = new TypeLotsMAPA();
    for (const lot of Array.from(lot_iters)) {
      lots.lot[lot_iter] = new Lot();
      const dateExecution = '_SepSep_Initial_SepSep_TypeLotsMAPA_index_' + (lot_iter + 1) + '_SepSep_Lot_SepAtt_dateExecution';
      lots.lot[lot_iter].dateExecution = this.sanitizeString(controls.get(dateExecution));
      const dateLivraison = '_SepSep_Initial_SepSep_TypeLotsMAPA_index_' + (lot_iter + 1) + '_SepSep_Lot_SepAtt_dateLivraison';
      lots.lot[lot_iter].dateLivraison = this.sanitizeString(controls.get(dateLivraison));
      lots.lot[lot_iter].description = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_TypeLotsMAPA_index_' + (lot_iter + 1) + '_SepSep_Lot_SepAtt_description'));
      lots.lot[lot_iter].numLot = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_TypeLotsMAPA_index_' + (lot_iter + 1) + '_SepSep_Lot_SepAtt_numLot'));
      lots.lot[lot_iter].quantite = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_TypeLotsMAPA_index_' + (lot_iter + 1) + '_SepSep_Lot_SepAtt_quantite'));
      lot_iter++;
    }
    if (controls.get('_SepSep_Initial_SepSep_TypeLotsMAPA_SepAtt_plusieursLot') === true) {
      lots.plusieursLot = '';
    } else {
      lots.plusieursLot = null;
    }
    if (controls.get('_SepSep_Initial_SepSep_TypeLotsMAPA_SepAtt_tousLots') === true) {
      lots.tousLots = '';
    } else {
      lots.tousLots = null;
    }
    if (controls.get('_SepSep_Initial_SepSep_TypeLotsMAPA_SepAtt_unLot') === true) {
      lots.unLot = '';
    } else {
      lots.unLot = null;
    }
    return lots;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
